import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  searchKeyword: "",
  flashcardsPage: 1,
  flashcard: {}
};

const flashCardQuestions = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_ALL_FLASH_CARD_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta
      };
    case types.GET_SINGLE_FLASH_CARD_RESPONSE:
      return {
        ...state,
        flashcard: action.payload
      };
    case types.DELETE_SINGLE_FLASH_CARD_RESPONSE:
      return {
        ...state,
        list: state.list.filter(
          (flashcard) => flashcard.id !== action.payload
        )
      };
    case types.SET_FLASH_CARD_SEARCH:
      return {
        ...state,
        searchKeyword: action.payload
      };
    case types.SET_FLASH_CARD_PAGE:
      return {
        ...state,
        flashcardsPage: action.payload
      };
    default:
      return state;
  }
};

export default flashCardQuestions;
